// @flow

import React from 'react';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

import type { IntlShape } from 'react-intl';

import iconSrc from './icon.png';

const Root = styled.button`
  position: relative;
  top: 3px;

  padding: 0;
  margin-left: 15px;
  border: none;

  text-transform: lowercase;

  background: transparent;
  color: #FCFCFC;

  outline: none;
  cursor: pointer;
`

type Props = {
  intl: IntlShape
}

function SearchButton({ intl }: Props) {
  return (
    <Root>
      <img
        src={iconSrc}
        width="20"
        height="20"
        alt={intl.formatMessage({ id: 'header.search' })}
      />
    </Root>
  );
}

export default injectIntl(SearchButton);



// WEBPACK FOOTER //
// ./src/components/Header/SearchButton/SearchButton.js